import React from 'react';
// import components
import Card from './components/Card';

const App = () => {
  return (
    <div className='w-full bg-[#b1a29d] h-screen flex items-center justify-center'>
      <Card />
    </div>
  );
};

export default App;
